export default "__VITE_ASSET__Q4QyXpe4__"